import { defineStore } from 'pinia'

export const usePlayBarStore = defineStore('playBar', {
  state: () => ({
    visible: false,
    dramaId: '',
    title: '',
    coverUrl: '',
    episodeNumber: 1,
    episodeId: '',
    /** 总集数（来自 dramaInfo.total） */
    total: 0
  }),
  actions: {
    /** Continue Bar 仅跟随当前页面会话，刷新后不恢复 */
    hydrate () {
      return null
    },
    setFromPlaying ({ dramaId, title, coverUrl, episodeNumber, episodeId, total }) {
      this.dramaId = String(dramaId ?? '')
      this.title = (title || '').trim()
      this.coverUrl = (coverUrl || '').trim()
      this.episodeNumber = Number(episodeNumber) > 0 ? Number(episodeNumber) : 1
      this.episodeId = episodeId != null ? String(episodeId) : ''
      this.total = Number(total) > 0 ? Number(total) : 0
      this.visible = true
    },
    clear () {
      this.visible = false
      this.dramaId = ''
      this.title = ''
      this.coverUrl = ''
      this.episodeNumber = 1
      this.episodeId = ''
      this.total = 0
    }
  }
})
